import React from "react";
import { Loader } from "../shared";

export default function LoadingIndicator({ isLoading }) {
  return (
    <>
      {isLoading ? (
        <Loader loading={isLoading} style={{ margin: "1rem" }} />
      ) : (
        <div style={{ width: "1rem", height: "1rem", lineHeight: "1rem", margin: "1rem" }}></div>
      )}
    </>
  );
}
